import { ModalConfirmButton } from '@dreryk/react-components';

import { patientMedicalInformationTranslationKeys } from '../../translations';

type MedicalInformationClosePreviewModalButtonProps = {
   readonly onClose: VoidFunction;
};

export const MedicalInformationClosePreviewModalButton = (
   props: MedicalInformationClosePreviewModalButtonProps
): JSX.Element => {
   return (
      <ModalConfirmButton
         label={patientMedicalInformationTranslationKeys.previewModal.closePreview}
         onClick={props.onClose}
      />
   );
};
